import i18n, { BackendModule } from "i18next";
import { initReactI18next } from "react-i18next";
import { isDevelopmentOrMockMode } from "./utils";
import localTranslationsEn from "../assets/i18n/en.json";
import localTranslationsSv from "../assets/i18n/sv.json";
import { LogLevel, logPost } from "../api/controllers/logController/logController";

const TRANSLATIONS_SERVICE_URL = import.meta.env.VITE_TRANSLATIONS_SERVICE_URL;
const TRANSLATIONS_APPLICATION_NAME = import.meta.env.VITE_TRANSLATIONS_APPLICATION_NAME;
const TRANSLATIONS_GROUP = import.meta.env.VITE_TRANSLATIONS_GROUP;

const customBackend: BackendModule = {
  type: "backend",
  init() {},
  read(language, namespace, callback) {
    if (isDevelopmentOrMockMode()) {
      if (language === "en") {
        callback(null, localTranslationsEn);
      } else if (language === "sv") {
        callback(null, localTranslationsSv);
      }
    } else {
      let url = `${TRANSLATIONS_SERVICE_URL}/${TRANSLATIONS_APPLICATION_NAME}?language=${language}`;
      if (TRANSLATIONS_GROUP) {
        url += `&group=${TRANSLATIONS_GROUP}`;
      }

      fetch(url, {
        headers: {
          accept: "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const { _metadata, ...translations } = data;
          callback(null, translations);
        })
        .catch((error) => {
          logPost({ message: `Failed to fetch translations from Content Delivery: ${error}`, level: LogLevel.Error });
          if (language === "en") {
            callback(null, localTranslationsEn);
          } else if (language === "sv") {
            callback(null, localTranslationsSv);
          } else {
            callback(error, false);
          }
        });
    }
  },
};

const initI18next = async () => {
  await i18n
    .use(initReactI18next)
    .use(customBackend)
    .init({
      backend: {
        customBackend,
      },
      fallbackLng: "en",
      interpolation: {
        escapeValue: false,
        prefix: "{",
        suffix: "}",
      },
    });
};

export default initI18next;
